import React, {useEffect, useState} from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import {useTheme} from "@emotion/react";
import {ROUND_BOX} from "../../_presentational/buttons";

/*
    props
    is_active : bool
    on_click : func(return void) = onFilterButtonClick
    content : string
 */
const ActiveBlackFilterButton = (props) => {
    // state
    const [is_active, setActive] = useState(props.is_active);

    // css style
    const {css} = useComponentStyle(props.is_active);

    useEffect(() => {
        setActive(props.is_active);
    }, [props.is_active]);

    return (
        <div
            onClick={() => {
                setActive(props.is_not_cancel ? props.is_not_cancel : !is_active);
                props.on_click && props.on_click(is_active);
            }}>
            <ROUND_BOX css={css.black_filter_button_css}>{props.content || ""}</ROUND_BOX>
        </div>
    );
};

export default ActiveBlackFilterButton;

export const useComponentStyle = (is_active) => {
    const theme = useTheme();
    return {
        css: {
            black_filter_button_css: css({
                cursor: "pointer",
                color: is_active ? theme.colors.w : theme.colors.dg2,
                backgroundColor: is_active ? theme.colors.black : theme.colors.w,
                fontSize: theme.font_size.f15,
                fontWeight: is_active ? "700" : "400",
                boxShadow: is_active && `1px 0 10px ${theme.colors.dg3}`,
                "@media (max-width: 320px)": {
                    fontSize: theme.font_size.f14,
                },
            }),
        },
    };
};
